import React from 'react';
import styled from 'styled-components/macro';
import BaseInput, { type InputProps as BaseInputProps } from '../../../ui/Input';
import { getFieldWrapStyle } from '../Field';

export type InputProps = {
  fontSize?: number
} & BaseInputProps

const StyledInput = styled(BaseInput)`
  & > div {
    padding: 0;
  }
`;

const Input = ({ style, error, fontSize = 18, ...props }: InputProps) => (
  <StyledInput {...props} error={error} style={getFieldWrapStyle(error, { fontSize, ...style })} />
);

export default Input;
